import { isAppButtonProps } from '../AppButton';
import { isAppCompoundButtonProps } from '../AppCompoundButton';
import { isAppFlyoutAnchorProps } from '../AppFlyoutAnchor';
import { isAppInkButtonProps } from '../AppInkButton';
import { isAppInkFlyoutAnchorProps } from '../AppInkFlyoutAnchor';
import { isAppSpinButtonProps } from '../AppSpinButton';
import { isAppSplitButtonProps } from '../AppSplitButton';
import { isAppToggleButtonProps } from '../AppToggleButton';

export const doesControlSupportTooltipsInMenus = (props: { type: string }): boolean => {
  return (
    isAppButtonProps(props) ||
    isAppToggleButtonProps(props) ||
    isAppCompoundButtonProps(props) ||
    isAppSplitButtonProps(props) ||
    isAppFlyoutAnchorProps(props) ||
    isAppInkButtonProps(props) ||
    isAppInkFlyoutAnchorProps(props) ||
    isAppSpinButtonProps(props)
  );
};
